import React from 'react'
import { Modal, Button } from '@sainsburys-tech/fable'
import { PropTypes } from 'prop-types'

const TCsChangedModal = (props) => {
  const {
    isOpen, continueClick
  } = props

  return (
    <Modal
      header={{
        label: 'Terms and conditions',
        isDismissible: false,
      }}
      isOpen={isOpen}
      onClose={continueClick}
      hasClickawayClose={false}
      size="xl"
      contentHeight="full"
      renderFooter={(
        <Button type="button" variant="primary" isFullWidth onClick={continueClick}>
          Continue to T&Cs
        </Button>
      )}
    >
      <div className="dsib-termsAndConditionsModal__content">
        <p>The terms and conditions have changed.</p>
        <p className="dsib-termsAndConditionsModal__messageGap">
          You will need to accept them before you can sign in.
        </p>
      </div>
    </Modal>
  )
}

TCsChangedModal.propTypes = {
  isOpen: PropTypes.bool,
  continueClick: PropTypes.func.isRequired
}

TCsChangedModal.defaultProps = {
  isOpen: false
}

export default TCsChangedModal
